import { CcfBox } from '@nice-ccf/ui-controls';
import styles from './simulator-v2.module.scss';
import { CcfAppHeader, CcfLyraHeader, getEnableLyraDesign } from '@nice-ccf/ui-components';
import SimulatorV2LeftNav from './simulator-v2-left-nav/simulator-v2-left-nav';
import SimulatorV2Dashboard from './simulator-v2-dashboard/simulator-v2-dashboard';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

/**
 * New Simulator Component to mimic the Call/Post feature from different sources
 * * @param props - its will take the list of conatct , current selected conatct and the onclick handler method
 * @returns
 * @example
 */
export function SimulatorV2() {
  const [selectedAction, setSelectedAction] = useState('All Journeys');
  const isTestEnvironment =
    window.location.hostname === 'd1s74gzjhz7gu0.cloudfront.net';
  const enableLyraDesign = useSelector(getEnableLyraDesign);
  return (
    <CcfBox display={'flex'} flexDirection={'column'} width={'100%'}>
      <Helmet>
        <title>
          {isTestEnvironment
            ? 'CXone Test Agent Simulator'
            : 'CXone Agent Simulator'}
        </title>
      </Helmet>
      {enableLyraDesign ? (
        <CcfLyraHeader showHeaderText={false} />
      ) : (
        <CcfAppHeader
          headerText={'CXone Simulator Settings'}
          showHeaderText={true}
        />
      )}

      <CcfBox className={styles.mainContainer}>
        <div className={styles.leftContainer}>
          <SimulatorV2LeftNav
            selectedAction={selectedAction}
            setSelectedAction={setSelectedAction}
          />
        </div>
        <div className={styles.rightContainer}>
          <SimulatorV2Dashboard selectedAction={selectedAction} />
        </div>
      </CcfBox>
    </CcfBox>
  );
}
export default SimulatorV2;
